// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./TableTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS component definition */

.Table-module__Container__Q9yeB {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    min-height: 0;
}

.Table-module__Table__MAvYt {
    position: relative;
    flex: 1;
}

.Table-module__NotScrollable__Hmu53 {
    flex: 0 0 auto;
}

.Table-module__FullHeight__SdFwX {
    height: 100%;
}

.Table-module__SortActive__pOZqr {
    color: var(--ds-table-sort-active);
}

.Table-module__NoPropagate__txuWX {
    cursor: default;
}

.Table-module__THeadVerticalScrollbar__Dgr0X {
    overflow-y: scroll;
}
/*
Below selector is needed in order to create stronger selector than the following global:
    :root {
        ::-webkit-scrollbar {
            ...
            background-color: var(--ds-scrollbar-bg-color);
        }
    }
*/
/* stylelint-disable-next-line selector-max-specificity -- needed to make thead scrollbar invisible */
.Table-module__Table__MAvYt .Table-module__THeadVerticalScrollbar__Dgr0X::-webkit-scrollbar {
    background-color: transparent;
}

.Table-module__EmptyState__GPeqX {
    position: absolute;
    top: 50%;
    left: 50%;
    color: var(--ds-table-empty-state-color);
    font-weight: var(--ds-font-weight-regular);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height);
    transform: translate(-50%, calc(-50% + var(--ds-l)));
}

.Table-module__Loading__eAUy9 {
    display: block;
    width: 100%;
}
/* Column Size Classes (flex-basis) */
.Table-module__ColSize12x__Sy5QU {
    /* 48px */
    flex-basis: var(--ds-12x);
}

.Table-module__ColSize18x__D_VRN {
    /* 72px */
    flex-basis: var(--ds-18x);
}

.Table-module__ColSize24x__WpQhH {
    /* 96px */
    flex-basis: var(--ds-24x);
}

.Table-module__ColSize32x__aEFce {
    /* 128px */
    flex-basis: var(--ds-32x);
}

.Table-module__ColSize41x__xMjEY {
    /* 164px */
    flex-basis: var(--ds-41x);
}

.Table-module__ColSize48x___GC43 {
    /* 192px */
    flex-basis: var(--ds-48x);
}

.Table-module__ColSize56x__Qd8cV {
    /* 224px */
    flex-basis: var(--ds-56x);
}

.Table-module__ColSize64x__BR849 {
    /* 256px */
    flex-basis: var(--ds-64x);
}

.Table-module__ColSize90x__DD9eN {
    /* 360px */
    flex-basis: var(--ds-90x);
}
/* Column Grow Classes (flex-grow and flex-shrink) */
/* fixed: No grow, no shrink - for menus, actions */
.Table-module__ColGrowFixed__WBTa3 {
    flex-grow: 0;
    flex-shrink: 0;
}
/* flex: Equal grow/shrink - standard content */
.Table-module__ColGrowFlex__MJeDx {
    flex-grow: 1;
    flex-shrink: 1;
}
/* flex-2: Grows 2x more - important content */
.Table-module__ColGrowFlex2__dc8b3 {
    flex-grow: 2;
    flex-shrink: 1;
}
/* flex-3: Grows 3x more - primary content */
.Table-module__ColGrowFlex3__A9KzY {
    flex-grow: 3;
    flex-shrink: 1;
}
/* flex-4: Grows 4x more - main content like names */
.Table-module__ColGrowFlex4__KGiF2 {
    flex-grow: 4;
    flex-shrink: 1;
}
/* no-shrink: Can grow, won't shrink */
.Table-module__ColGrowNoShrink__H2e5b {
    flex-grow: 1;
    flex-shrink: 0;
}
/* Column Utility Classes */
/* Enable text overflow/truncation */
.Table-module__ColUtilOverflow__vP3f4 {
    min-width: 0;
    overflow: hidden;
}
/* Right-align content */
.Table-module__ColUtilJustifyEnd__kuoIV {
    justify-content: flex-end;
}
/* Center-align content */
.Table-module__ColUtilJustifyCenter__ScrNb {
    justify-content: center;
}
/* Pointer cursor for clickable columns */
.Table-module__ColUtilPointer__i1gkb {
    cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Table-module__Container__Q9yeB`,
	"Table": `Table-module__Table__MAvYt`,
	"NotScrollable": `Table-module__NotScrollable__Hmu53`,
	"FullHeight": `Table-module__FullHeight__SdFwX`,
	"SortActive": `Table-module__SortActive__pOZqr`,
	"NoPropagate": `Table-module__NoPropagate__txuWX`,
	"THeadVerticalScrollbar": `Table-module__THeadVerticalScrollbar__Dgr0X`,
	"EmptyState": `Table-module__EmptyState__GPeqX`,
	"Loading": `Table-module__Loading__eAUy9`,
	"ColSize12x": `Table-module__ColSize12x__Sy5QU`,
	"ColSize18x": `Table-module__ColSize18x__D_VRN`,
	"ColSize24x": `Table-module__ColSize24x__WpQhH`,
	"ColSize32x": `Table-module__ColSize32x__aEFce`,
	"ColSize41x": `Table-module__ColSize41x__xMjEY`,
	"ColSize48x": `Table-module__ColSize48x___GC43`,
	"ColSize56x": `Table-module__ColSize56x__Qd8cV`,
	"ColSize64x": `Table-module__ColSize64x__BR849`,
	"ColSize90x": `Table-module__ColSize90x__DD9eN`,
	"ColGrowFixed": `Table-module__ColGrowFixed__WBTa3`,
	"ColGrowFlex": `Table-module__ColGrowFlex__MJeDx`,
	"ColGrowFlex2": `Table-module__ColGrowFlex2__dc8b3`,
	"ColGrowFlex3": `Table-module__ColGrowFlex3__A9KzY`,
	"ColGrowFlex4": `Table-module__ColGrowFlex4__KGiF2`,
	"ColGrowNoShrink": `Table-module__ColGrowNoShrink__H2e5b`,
	"ColUtilOverflow": `Table-module__ColUtilOverflow__vP3f4`,
	"ColUtilJustifyEnd": `Table-module__ColUtilJustifyEnd__kuoIV`,
	"ColUtilJustifyCenter": `Table-module__ColUtilJustifyCenter__ScrNb`,
	"ColUtilPointer": `Table-module__ColUtilPointer__i1gkb`
};
export default ___CSS_LOADER_EXPORT___;
